/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { NotificationsService, NotificationType } from 'angular2-notifications';
import { AnalyticsService } from './@core/utils/analytics.service';
//import { MessagingService } from './messaging.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet><simple-notifications></simple-notifications>',
})
export class AppComponent implements OnInit {
  //message;
  // private message = {
  //   Imei: "",
  //   Type: 0, 
  //   Noidung: "", 
  //   CreatDate: new Date,
  //   Bienso: ""
  // };
  constructor(private analytics: AnalyticsService) {
  }

  ngOnInit(){
    this.analytics.trackPageViews();
  }
}
